import {combineReducers} from 'redux';
import mpp from './other/mpp';
import mpm from './other/mpm';

export default combineReducers({
  mpp,
  mpm,
});



// WEBPACK FOOTER //
// ./src/reducers/app/other.js